import React from 'react';
import Helmet from 'react-helmet';
import icon from '../assets/favicon.ico';

import "./index.css";

export default ({ children }) => (

    <div className="font-base antialiased font-base leading-normal">

        <Helmet title="Nigala | Evaluation App"
            meta={[
                { name: 'description', content: 'Evaluation Application' },
            ]}
            link={[
                { rel: 'shortcut icon', type: 'image/png', href: `${icon}` }
            ]}
        />

        {children()}

    </div>
);


// WEBPACK FOOTER //
// ./src/layouts/index.js